import vuex from 'vuex'
import Vue from 'vue'
import storage from "@/utils/storage";
import utils from "@/utils/utils";

Vue.use(vuex);
var store = new vuex.Store({
  state:{
    // 用户信息
    userInfo: {},
    // day白天 night夜晚
    dark: 'day',
    // zh-CN中文 en-US英文
    lang: 'zh-CN',
    // 更新是否展示
    updateTipsVisible: false,
    // 更新信息
    updateInfo: {},
  },
  mutations:{
    // 更新信息
    changeUpdateInfo(state, data){
      state.updateInfo = data || {};
    },
    // 更新是否展示
    changeUpdateTipsVisible(state, data){
      state.updateTipsVisible = data || false;
    },
    // 修改
    changeUserInfo(state, data){
      state.userInfo = data || {};
    },
    // 修改模式
    changeDark(state, data){
      let d = state.dark || 'day'
      d = d === 'night' ? 'day' : 'night'

      state.dark = d
      storage.setdark(d)
    },

    // 修改语言
    changeLang(state, data){
      let d = data || 'zh-CN'

      state.lang = d
      storage.setLang(d)

      // 通知客户端
      utils.getClientFn('SetLanguage', {
        'zh-CN': 1,
        'en-US': 0
      }[d])
    },
  }
})

export default store



// WEBPACK FOOTER //
// ./src/utils/store.js